export const DurationType = {
  Yearly: 'Yearly',
  Month: 'Month',
} as const;
export type DurationType = (typeof DurationType)[keyof typeof DurationType];
